var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNoProducts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 116,
    viewBox: "0 0 114 116",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4346 46.6367H87.165V98.7254C87.165 98.8315 87.1228 98.9333 87.0478 99.0083C86.9728 99.0833 86.8711 99.1254 86.765 99.1254H19.8346C19.7285 99.1254 19.6267 99.0833 19.5517 99.0083C19.4767 98.9333 19.4346 98.8315 19.4346 98.7254V46.6367Z",
    fill: "#E9EAEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1736 26.2241H38.6804L19.4346 46.6364H87.165L70.1736 26.2241Z",
    fill: "#A4A7AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85 18.0596L38.6806 26.2245L19.4347 46.6368L4.85449 35.5558L25.85 18.0596Z",
    fill: "#E9EAEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0044 18.0596L70.1738 26.2245L87.1652 46.6368L104 35.5558L83.0044 18.0596Z",
    fill: "#E9EAEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9544 18.4768C47.3165 18.3051 47.5982 18.0002 47.7406 17.6256C47.8831 17.2511 47.8753 16.836 47.7189 16.4671L41.947 2.85688C41.8652 2.6641 41.7453 2.48984 41.5945 2.34458C41.4437 2.19932 41.265 2.08607 41.0693 2.01162C40.8736 1.93717 40.6648 1.90308 40.4556 1.91138C40.2464 1.91968 40.041 1.97021 39.8517 2.05992L38.7397 2.5872C38.5505 2.67692 38.3814 2.80397 38.2426 2.96071C38.1037 3.11745 37.998 3.30065 37.9318 3.4993C37.8656 3.69795 37.8402 3.90793 37.8572 4.11664C37.8742 4.32534 37.9332 4.52846 38.0307 4.71377L44.9146 17.7966C45.1012 18.1513 45.4176 18.4201 45.7977 18.5468C46.1779 18.6736 46.5923 18.6485 46.9544 18.4768Z",
    fill: "#E9EAEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.191 17.1574C54.453 17.1387 54.6977 17.0195 54.8739 16.8247C55.0502 16.6298 55.1443 16.3745 55.1366 16.1119L54.8515 6.42257C54.8475 6.28532 54.8157 6.15031 54.7582 6.02565C54.7006 5.90099 54.6185 5.78925 54.5166 5.69716C54.4148 5.60506 54.2954 5.53451 54.1656 5.48974C54.0358 5.44497 53.8982 5.42691 53.7613 5.43664L52.9563 5.49401C52.8193 5.50375 52.6858 5.54108 52.5637 5.60374C52.4416 5.6664 52.3334 5.7531 52.2456 5.85863C52.1579 5.96417 52.0923 6.08636 52.053 6.21786C52.0136 6.34936 52.0013 6.48745 52.0167 6.62385L53.1068 16.2559C53.1363 16.517 53.2656 16.7566 53.4676 16.9246C53.6697 17.0926 53.9289 17.176 54.191 17.1574Z",
    fill: "#A4A7AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7772 20.7392C60.498 21.1559 61.5099 20.7735 62.0711 19.8721L72.0363 3.86791C72.6316 2.91183 72.4905 1.74655 71.726 1.30455L70.6604 0.688553C69.896 0.246473 68.8156 0.705512 68.284 1.69839L59.3844 18.3185C58.8832 19.2546 59.0564 20.3224 59.7772 20.7392Z",
    fill: "#D5D7DA"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-products.c60b953e.svg";
export { ForwardRef as ReactComponent };